export const quotes = [
    {
    quote: "Bolt allows us to organize our puzzles and clues to match how we run games. This makes for a more uniform experience.",
    name: "Brannon B.",
    company: "Escape Quest",
    location: "Washington, DC"
  }
]